import AppThemeIcon from "@core-components/icon/AppThemeIcon";
import Icon from "@core-components/icon/Icon";
import EPublicRoutes from "@core-types/routes.enum";
import { useAppNavigate } from "@hooks/language/useAppNavigate";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Group } from "@mantine/core";
import SSSection from "./Section";

const HowToUnlockSkin: React.FC = () => {
  const { t } = useAppTranslation("pages.order.tracking");
  const { navigate } = useAppNavigate();

  const title = (
    <Group wrap="nowrap">
      {t("unlockSkin")}
      <AppThemeIcon className="size-5">
        <Icon.NewTab />
      </AppThemeIcon>
    </Group>
  );

  return (
    <SSSection
      fullHeight={false}
      withDivider={false}
      icon={<Icon.GreenOpenLock size={20} />}
      title={title}
      classNames={{ root: "!p-8 cursor-pointer", title: "!pb-0" }}
      onClick={() =>
        navigate(EPublicRoutes.FAQ_GET_SKINS, { openInNewTab: true })
      }
    />
  );
};

export default HowToUnlockSkin;
